import script from "./PaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethod.vue?vue&type=style&index=0&id=90c7ad06&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90c7ad06"]])

export default __exports__